import { createContext } from 'react'
import type TC_Wrapper from 'react-tag-commander'

export const TrackingContext = createContext<TC_Wrapper | undefined>(null)
